import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import _slicedToArray from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Focus from "./components/Focus/Focus";
import QuickEntry from "./components/QuickEntry/QuickEntry";
import Exclusive from "./components/Exclusive/Exclusive";
import SecondKill from "./components/SecondKill/SecondKill";
import { LeafType } from '@/util/const';
import PopAct from "./components/PopAct/PopAct";
import PopSuc from "../../components/item/SecondKillItem/AskFollow/AskFollow";
import Email from "./components/Email/Email";
import QmAdv from "./components/QmAdv/QmAdv";

// client js begin
import bus from '@/util/bus';
import env from '@tencent/vft-common/env';
var tenvideoModule = function tenvideoModule() {
  return import('@tencent/vft-common/tenvideo').then(function (mod) {
    return mod.default;
  });
};
var utilModule = function utilModule() {
  return import('@tencent/vft-common/util').then(function (mod) {
    return mod.default;
  });
};
var tenvideoServiceModule = function tenvideoServiceModule() {
  return import('@tencent/vft-union-fetch/src/tenvideoService');
};
try {
  window.aegis.reportTime('可交互', window.interactive);
  window.aegis.reportTime('首屏', window.firstPaint);
} catch (error) {
  console.log('aegis上报报错', error);
}
// client js end

export default {
  data: function data() {
    return {
      LeafType: LeafType,
      isFetching: false,
      error: null
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this = this;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.registerResizeEvent();
              _context2.prev = 1;
              if (this.welfare) {
                _context2.next = 5;
                break;
              }
              _context2.next = 5;
              return this.$store.dispatch('indexPageModule/getWelfare');
            case 5:
              _context2.next = 12;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              console.log('重新获取welfare失败。。。。。', _context2.t0);
              this.error = _context2.t0.message;
              throw _context2.t0;
            case 12:
              this.$store.dispatch('startTimer', this.welfare.lNows);

              //    this.initListener()

              this.registerRefreshEvent();
              this.registerLoginEvent();
              this.initShareInfo();
              _context2.next = 18;
              return this.pageReady;
            case 18:
              this.initReportReady();
              if (!window.pageIsOnload) {
                _context2.next = 28;
                break;
              }
            case 20:
              if (this.isEnd) {
                _context2.next = 25;
                break;
              }
              _context2.next = 23;
              return this.loadMoreWelfare();
            case 23:
              _context2.next = 20;
              break;
            case 25:
              setTimeout(function () {
                // 非app内不走sessionStorage
                if (!sessionStorage.getItem('scroll') || !env.isApp) {
                  _this.toOneModule();
                }
              }, 500);
              _context2.next = 29;
              break;
            case 28:
              window.addEventListener('load', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (_this.isEnd) {
                          _context.next = 5;
                          break;
                        }
                        _context.next = 3;
                        return _this.loadMoreWelfare();
                      case 3:
                        _context.next = 0;
                        break;
                      case 5:
                        setTimeout(function () {
                          if (!sessionStorage.getItem('scroll') || !env.isApp) {
                            _this.toOneModule();
                          }
                        }, 500);
                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 7]]);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  computed: {
    welfare: function welfare() {
      return this.$store.state.indexPageModule.welfare;
    },
    isEnd: function isEnd() {
      return this.$store.getters['indexPageModule/isEnd'];
    }
  },
  methods: {
    initReportReady: function () {
      var _initReportReady = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;
        var tenvideoService, tenvideo, util, isEnter, startReport;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return tenvideoServiceModule();
              case 2:
                tenvideoService = _context3.sent;
                _context3.next = 5;
                return tenvideoModule();
              case 5:
                tenvideo = _context3.sent;
                _context3.next = 8;
                return utilModule();
              case 8:
                util = _context3.sent;
                if (env.isIphone && env.isApp && tenvideo.getAppVersion() >= '5.8.5' && util.getUrlParam('ptag') === 'app_tab') {
                  isEnter = false;
                  startReport = function startReport() {
                    if (!isEnter) {
                      isEnter = true;
                      _this2.$reportReady();
                      _this2.universalReporterReady();
                    }
                  };
                  tenvideoService.tenvideoOn('onPageAppear', startReport);
                  document.addEventListener('touchstart', startReport, true);
                } else {
                  this.$reportReady();
                  this.universalReporterReady();
                }
              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function initReportReady() {
        return _initReportReady.apply(this, arguments);
      }
      return initReportReady;
    }(),
    registerLoginEvent: function () {
      var _registerLoginEvent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var tenvideoService;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return tenvideoServiceModule();
              case 2:
                tenvideoService = _context4.sent;
                if (tenvideoService.isAllTenvideo()) {
                  tenvideoService.onActionLoginFinish(function () {
                    setTimeout(function () {
                      window.location.reload();
                    }, 0);
                  });
                  tenvideoService.tenvideoOn('onActionLogoutFinish', function () {
                    setTimeout(function () {
                      window.location.reload();
                    }, 0);
                  });
                  tenvideoService.tenvideoOn('onIAPPaySuccess', function () {
                    setTimeout(function () {
                      window.location.reload();
                    }, 0);
                  });
                }
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      function registerLoginEvent() {
        return _registerLoginEvent.apply(this, arguments);
      }
      return registerLoginEvent;
    }(),
    registerRefreshEvent: function () {
      var _registerRefreshEvent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this3 = this;
        var _yield$import, register, complete, refresh;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return import('@/util/pull2Refresh');
              case 2:
                _yield$import = _context6.sent;
                register = _yield$import.register;
                complete = _yield$import.complete;
                refresh = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return _this3.$store.dispatch('getPayVipAndUserInfo');
                          case 2:
                            _context5.next = 4;
                            return _this3.$store.dispatch('indexPageModule/refreshWelfare');
                          case 4:
                            if (_this3.isEnd) {
                              _context5.next = 9;
                              break;
                            }
                            _context5.next = 7;
                            return _this3.loadMoreWelfare();
                          case 7:
                            _context5.next = 4;
                            break;
                          case 9:
                            _this3.$nextTick(function () {
                              bus.$emit('pull2Refresh');
                              complete();
                            });
                          case 10:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));
                  return function refresh() {
                    return _ref2.apply(this, arguments);
                  };
                }();
                register(refresh);
                window.p2r = refresh;
              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      function registerRefreshEvent() {
        return _registerRefreshEvent.apply(this, arguments);
      }
      return registerRefreshEvent;
    }(),
    loadMoreWelfare: function () {
      var _loadMoreWelfare = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.isFetching = true;
                _context7.next = 3;
                return this.$store.dispatch('indexPageModule/getWelfare');
              case 3:
                this.isFetching = false;
              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function loadMoreWelfare() {
        return _loadMoreWelfare.apply(this, arguments);
      }
      return loadMoreWelfare;
    }(),
    toOneModule: function () {
      var _toOneModule = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var util, modid, _ref3, _ref4, _ref4$, element, top;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return utilModule();
              case 2:
                util = _context8.sent;
                modid = this.getFirstParam(util);
                _ref3 = this.$refs[modid] || [], _ref4 = _slicedToArray(_ref3, 1), _ref4$ = _ref4[0];
                _ref4$ = _ref4$ === void 0 ? {} : _ref4$;
                element = _ref4$.$el;
                if (element) {
                  _context8.next = 9;
                  break;
                }
                return _context8.abrupt("return");
              case 9:
                top = element.offsetTop; // 兼容 二者只会有一个起作用
                document.documentElement.scrollTop = top;
                document.body.scrollTop = top;
                // app内记录滚动
                if (env.isApp) {
                  sessionStorage.setItem('scroll', true);
                }
              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function toOneModule() {
        return _toOneModule.apply(this, arguments);
      }
      return toOneModule;
    }(),
    getFirstParam: function getFirstParam(util) {
      var u = location.href;
      var reg = new RegExp("[?&#]modid=([^&#]+)", 'gi');
      var matches = u.match(reg);
      var strArr;
      if (matches && matches.length > 0) {
        strArr = matches[0].split('=');
        if (strArr && strArr.length > 1) {
          // 过滤XSS字符
          return util.filterXSS(strArr[1]);
        }
        return '';
      }
      return '';
    },
    // 监听屏幕尺寸变化事件
    registerResizeEvent: function registerResizeEvent() {
      var _this4 = this;
      this.$store.dispatch('setDeviceSize');
      window.onresize = function () {
        _this4.$store.dispatch('setDeviceSize');
      };
    },
    universalReporterReady: function universalReporterReady() {
      if (!window.universalReporter) return;
      var pageId = 'welfare';
      window.universalReporter.reporter.setPage({
        pgid: pageId,
        contentid: "".concat(pageId, "_init")
      }, document.body).observe(pageId);
      window.universalReporter.reporter.initPage();
    }
  },
  components: {
    Focus: Focus,
    QuickEntry: QuickEntry,
    Exclusive: Exclusive,
    SecondKill: SecondKill,
    PopSuc: PopSuc,
    PopAct: PopAct,
    OfflineAct: function OfflineAct() {
      return import("./components/OfflineAct/OfflineAct");
    },
    NormalMod: function NormalMod() {
      return import("./components/NormalMod/NormalMod");
    },
    RenewMod: function RenewMod() {
      return import("./components/RenewMod/RenewMod");
    },
    TabMod: function TabMod() {
      return import("./components/TabMod/TabMod");
    },
    Error: function Error() {
      return import('@/components/base/Error/Error.vue');
    },
    Email: Email,
    QmAdv: QmAdv
  },
  reportModule: '福利社首页'
};